// extracted by mini-css-extract-plugin
export var paragraph = "Video-module--paragraph--uhX6o";
export var playButton = "Video-module--play-button--UGJxy";
export var title = "Video-module--title--zcZw+";
export var video = "Video-module--video--P2oKJ";
export var wrapper = "Video-module--wrapper--peJsr";